import React from "react";
import Image from "react-bootstrap/Image";
import { ReusableOnboardingButton } from "../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import RightSidePannel from "../../rightSidePannelReusable/RightSidePannel";

export const OrderingScreen = ({
  onPageChangeHandlerClosed,
  onClick,
  displayScreen,
  takeAway,
  dinein,
  curbside,
  driveThru,
  fastFoodMenuSetup,
  fastFoodOrdering,
  onOrderingPageSubmit,
}) => {
  return (
    <React.Fragment>
      <div className="col-12 onboarding-back-button-all-screen">
        <div className="back_button-link" onClick={onPageChangeHandlerClosed}>
          <Image
            src={require("../../../../../assets/images/Icon/onBoardBack.png")}
            alt="Back Button"
            title="Back Button"
          />
        </div>
      </div>
      <div className="display-toggle-stepup-button">
        <RightSidePannel selectedTab={4} />
      </div>
      <div className="subscription_component_onboarding_main ">
        <div className="subscription-main-screen-box mb-4">
          <div className="subscription-menu-one" onClick={onClick}>
            <div
              className={
                displayScreen === false
                  ? "subscription-menu-one-imageBox subscription-menu-one-imageBox-active"
                  : "subscription-menu-one-imageBox"
              }
            >
              <Image
                src={
                  displayScreen === false
                    ? require("../../../../../assets/images/onboarding/orderingWhite.png")
                    : require("../../../../../assets/images/onboarding/orderingRed.png")
                }
                fluid
                alt="icon"
                title="Subscription Icon"
              />
            </div>
            <h5>Casual/Fine Dining</h5>
            <hr
              className={
                displayScreen === false ? "Casual-fine-dining" : "d-none"
              }
            />
          </div>
          <div className="subscription-menu-one" onClick={onClick}>
            <div
              className={
                displayScreen === true
                  ? "subscription-menu-one-imageBox subscription-menu-one-imageBox-active"
                  : "subscription-menu-one-imageBox"
              }
            >
              <Image
                src={
                  displayScreen === true
                    ? require("../../../../../assets/images/onboarding/orderingWhite.png")
                    : require("../../../../../assets/images/onboarding/orderingRed.png")
                }
                fluid
                alt="icon"
                title="Subscription Icon"
              />
            </div>
            <h5>Fast Food and other</h5>
            <hr
              className={
                displayScreen === true ? "Casual-fine-dining" : "d-none"
              }
            />
          </div>
        </div>
        <div className="subscription-main-screen-box-Two">
          {displayScreen === false ? (
            <div>
              <div className="subscription-main-screen-box-Two-ordering">
                <h5>Ordering</h5>
                <hr />
              </div>
              <div className="section-one-align">
                <h5>TakeAway</h5>
                {takeAway}
              </div>
              <div className="section-one-align">
                <h5>Dine- In / Order Ahead</h5>
                {dinein}
              </div>
              <div className="section-one-align">
                <h5>Curbside</h5>
                {curbside}
              </div>
              <div className="section-one-align">
                <h5>Drive Thru</h5>
                {driveThru}
              </div>
            </div>
          ) : (
            <div>
              <div className="section-one-align">
                <h5>Menu Set Up</h5>
                {fastFoodMenuSetup}
              </div>
              <div className="section-one-align">
                <h5>Ordering</h5>
                {fastFoodOrdering}
              </div>
            </div>
          )}
        </div>
        <div className="onboarding-map-setup-screen-autodetect-button">
          <ReusableOnboardingButton
            buttonTitle="Back Button"
            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
            buttonText="Back"
            onClick={onPageChangeHandlerClosed}
          />

          <ReusableOnboardingButton
            buttonTitle="Next Button"
            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
            buttonText="Next"
            buttonType="button"
            onClick={onOrderingPageSubmit}
          />
        </div>
      </div>
    </React.Fragment>
  );
};
